import { useMutation, useQueryClient } from "@tanstack/react-query";
import { AxiosError } from "axios";

import { logger } from "#app/monitoring/Logger";
import { showErrorToast, showSuccessToast } from "#app/notifications";
import { quoteRequestQuery } from "#modules/quoteRequests/infra/quoteRequest.query";
import { quoteRequestsQuery } from "#modules/quoteRequests/infra/quoteRequests.query";
import { Batch, createQuote, Quote } from "#modules/quotes/infra/createQuote.api";

export const useCreateQuote = (
  quoteRequestId: string,
  options?: {
    onSuccess?: (quote: Quote) => void;
  },
) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (data: { batches: Batch[] }) =>
      await createQuote({ quoteRequestId, batches: data.batches }),
    onSuccess: async (quote) => {
      if (quote) {
        await queryClient.invalidateQueries(quoteRequestsQuery());
        await queryClient.invalidateQueries(quoteRequestQuery(quoteRequestId));

        options?.onSuccess?.(quote);

        showSuccessToast({
          title: `Devis créé sous la référence ${quote.version}`,
        });
      }
    },
    onError: (e: AxiosError) => {
      logger.error(e.message);
      showErrorToast({ title: "Erreur lors de la création du devis" });
    },
  });
};
